import { Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IDroppedFile } from '@shared/ui-components/au-file-loader/au-file-loader.interfaces';
import { MatIcon } from '@angular/material/icon';
import { MatRipple } from '@angular/material/core';
import { FileViewerComponent } from './file-viewer/file-viewer.component';
import { NgClass } from '@angular/common';

@Component({
	templateUrl: './file-viewer-modal.component.html',
	styleUrls: ['./file-viewer-modal.component.scss'],
	imports: [MatIcon, MatRipple, FileViewerComponent, NgClass],
})
export class FileViewerModalComponent {
	currentIndex = 0;
	filesList: Partial<IDroppedFile>[] = [];
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.key == 'ArrowLeft') {
			this.scrollLeft();
		} else if (event.key == 'ArrowRight') {
			this.scrollRight();
		}
	}

	constructor(
		@Inject(MAT_DIALOG_DATA)
		public data: { files: Partial<IDroppedFile>[]; index: number },
		private dialogRef: MatDialogRef<FileViewerModalComponent>
	) {
		this.currentIndex = data.index;
		this.filesList = data.files;
	}

	close() {
		this.dialogRef.close();
	}

	scrollLeft() {
		if (this.currentIndex > 0) {
			this.currentIndex--;
		}
	}

	scrollRight() {
		if (this.currentIndex < this.filesList.length - 1) {
			this.currentIndex++;
		}
	}

	get currentFile() {
		return this.filesList[this.currentIndex];
	}

	// Function to update the private name property
}
